// Bar Cabrero — single source of truth for contact info
export const WA_NUMBER = '34654233407';
export const WA_URL = `https://wa.me/${WA_NUMBER}`;
export const TEL_DISPLAY = '+34 654 23 34 07';
export const TEL_HREF = 'tel:+34654233407';

/**
 * Strict URL encoder for the WhatsApp `text` query param.
 * encodeURIComponent leaves !'()* unencoded, but the api.whatsapp.com parser
 * can choke on `!` (breaks the redirect on some clients). Manually escape those.
 */
export function encodeWaText(s) {
  return encodeURIComponent(s).replace(
    /[!'()*]/g,
    (c) => '%' + c.charCodeAt(0).toString(16).toUpperCase(),
  );
}

/**
 * Build a WhatsApp click-to-chat link with a pre-filled message.
 * Format: https://wa.me/{phone}?text={encoded_text} — the simplest scheme.
 *
 * Defensively strips '!' (replaced by '.') because `%21` adjacent to other
 * encoded punctuation has caused parser failures on some WhatsApp clients.
 */
export function waLink(text) {
  if (!text) return WA_URL;
  const sanitized = text.replace(/!/g, '.');
  return `${WA_URL}?text=${encodeWaText(sanitized)}`;
}

/** Strip accents/diacritics — keep WhatsApp messages ASCII-safe. */
export function stripAccents(s) {
  return s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
